import account from "./account";
import item from "./item";
import warehouse from "./warehouse";
import role from './role';
import dimension from './dimension';
import user from './user';
import permission from './permission'
import { getPermissions } from './../../../services/stockJournal/roles';
import { getDrafts } from './../../../services/stockJournal/index';

export default {
    namespaced: true,
    state: {
        userAccountsIDs: [],
        userWarehousesIDs: [],
        userItemsIDs: [],
        drafts: []
    },
    modules: {
        account,
        item,
        warehouse,
        role,
        dimension,
        user,
        permission
    },
    mutations: {
        setUserAccountsIDs(state, payload) {
            let accounts = payload.map(each => Number(each));
            state.userAccountsIDs = accounts;
        },
        setUserWarehousesIDs(state, payload) {
            let warehouses = payload.map(each => Number(each));
            state.userWarehousesIDs = warehouses;
        },
        setUserItemsIDs(state, payload) {
            let items = payload.map(each => Number(each));
            state.userItemsIDs = items;
        },
        setDrafts(state, payload) {
            state.drafts = payload
        }
    },
    actions: {
        fetchUserPermissions(context) {
            return new Promise((resolve, reject) => {
                getPermissions().then(response => {
                    context.commit("setUserAccountsIDs", response.data.accounts);
                    context.commit("setUserItemsIDs", response.data.items);
                    context.commit("setUserWarehousesIDs", response.data.warehouses);
                    resolve(response);
                }).catch(error => reject(error));
            });
        },
        fetchDrafts(context, payload) {
            return new Promise((resolve, reject) => {
                getDrafts(payload.type).then(response => {
                    context.commit("setDrafts", response.data);
                    resolve(response);
                }).catch(error => reject(error));
            });
        }
    },
    getters: {
        drafts(state) {
            return state.drafts
        },
        userWarehousesIDs(state) {
            return state.userWarehousesIDs
        },
        userItemsIDs(state) {
            return state.userItemsIDs
        }
    }
}